import PropTypes from 'prop-types';
import { Typography, Box, TextField, Autocomplete } from '@mui/material';

FormDropdown.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array,
  ]),
  title: PropTypes.string,
  width: PropTypes.string,
  setValue: PropTypes.func,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.string,
  options: PropTypes.array,
  isOptionEqualToValue: PropTypes.func,
  getOptionLabel: PropTypes.func,
  label: PropTypes.string,
  minWidth: PropTypes.string,
  multiple: PropTypes.bool,
  sx: PropTypes.object,
  disableClearable: PropTypes.bool,
  freeSolo: PropTypes.bool,
  autoComplete: PropTypes.oneOf(['off', 'no-autocomplete']),
  id: PropTypes.string,
};

export default function FormDropdown({
  value,
  title,
  width,
  disabled,
  fullWidth,
  onInputChange,
  size = 'small',
  onChange,
  options,
  isOptionEqualToValue,
  getOptionLabel,
  label,
  minWidth,
  multiple = false,
  sx,
  disableClearable = false,
  freeSolo = false,
  autoComplete = 'off',
  id = undefined
}) {
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
          {title}
        </Typography>

        <Autocomplete
          freeSolo={freeSolo}
          multiple={multiple}
          size={size}
          disabled={disabled}
          disableClearable={disableClearable}
          fullWidth={fullWidth}
          value={value}
          onInputChange={onInputChange}
          onChange={onChange}
          options={options}
          isOptionEqualToValue={isOptionEqualToValue}
          getOptionLabel={getOptionLabel}
          renderInput={(params) => <TextField
            {...params}
            label={label}
            inputProps={{...params.inputProps, autoComplete, id: id || params.id}}
          />}
          sx={{
            ...sx,
            width,
            minWidth,
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiFormLabel-root ': { display: 'none' },
          }}
        />
      </Box>
    </>
  );
}
